import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import DashboardReport from '../DashboardReport/DashboardReport';
import { dashboardType } from '../DashboardReport/index';

/**
 * Component for showing the org dashboard report data
 *
 * @param {*} { parentFilter, onClickFilter }
 * @returns
 */
const BotDashboard = ({ filter, subPage }) => {
  const [parentFilter, setParentFilter] = useState(filter);

  return (
    <DashboardReport filter={filter} currentDashboardType={dashboardType.BOT} />
  );
};

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BotDashboard)
);
